<template>
  <div>
    <simple-filters @filter="filter" :title="filterOptions.categoryName" :items="filterOptions.categories" />
    <tabbed-filters @filter="filter" title="Entidades" :items="filterOptions.entities" v-if="!!filterOptions.entities && filterOptions.entities.length>0" class="mt-3"/>
    <simple-filters @filter="filter" title="Polaridad" :items="filterOptions.polarities" class="mt-3"/>
  </div>
</template>

<script>
import SimpleFilters from "@/components/dashboard/filters/SimpleFilters.vue";
import TabbedFilters from "@/components/dashboard/filters/TabbedFilters.vue";

export default {
  components: {
    SimpleFilters,
    TabbedFilters
  },
  props: {
    filterOptions: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    filter(filters) {
      this.$emit("filter", filters);
    },
  },
};
</script>

<style>
</style>